import {Tree, TreeNode} from 'vue-tree-list'

const mixin = {
    data() {
        return {
            tree: new Tree([
                this.generateNode({
                    id: '1',
                    name: 'Raiz',
                    dragDisabled: true,
                    editable: true,
                    editNodeDisabled: false,
                    delNodeDisabled: true,
                })
            ])
        }
    },
    methods: {
        generateNode(element) {
            const id = element.id ? element.id : Math.random().toString(36).substr(2, 9)
            const name = element && element.name ? element.name : 'New Node'
            const type = element.type ? element.type : 'Array'
            const editable = element.editable ? element.editable : true
            const editNodeDisabled = element.editNodeDisabled ? element.editNodeDisabled : false
            const delNodeDisabled = element.delNodeDisabled ? element.delNodeDisabled : false
            const pid = element.pid ? element.pid : null
            const parent = element.parent ? element.parent : null
            const field = element.field ? element.field : null
            const isLeaf = element.isLeaf ? element.isLeaf : false
            const isAttribute = element.isAttribute ? element.isAttribute : false
            const isForeingKey = element.isForeingKey ? element.isForeingKey : false
            const foreingNode = element.foreingNode ? element.foreingNode : null
            const foreingField = element.foreingField ? element.foreingField : null

            let NodeGenerated = new TreeNode({
                id,
                name,
                type,
                editable,
                editNodeDisabled,
                delNodeDisabled,
                pid,
                parent,
                field,
                isLeaf,
                isAttribute,
                isForeingKey,
                foreingNode,
                foreingField
            })

            if (element.children && element.children.length > 0) {
                NodeGenerated.children = element.children
            }

            return NodeGenerated
        },
        onAdd(params) {
            const parent = this.findNodeById(this.data, params.parent.id)
            const children = this.generateNode({id: String(params.id), ...params})
            params.remove()
            parent.children.push(children)
        },
        onDel(node) {
            let parent = this.findNodeById(this.tree, node.pid)
            node.remove()

            if (!parent.children || parent.children && parent.children.length === 0) {
                parent.type = 'Info'
                parent.isLeaf = true

                const grandParent = this.findNodeById(this.tree, parent.pid)
                if (grandParent) {
                    parent = this.findNodeById(grandParent, parent.id)
                    parent.type = 'Info'
                    parent.isLeaf = true
                    grandParent.children[parent.index] = this.generateNode(parent)
                }

                this.$forceUpdate()
            }
        },
        findNodeById(parent, id) {
            if (parent.id === id) {
                return {...parent, index: 0}
            }

            if (parent.children && parent.children.length > 0) {
                let node, child = null;
                for (let i = 0, len = parent.children.length; i < len; i++) {
                    child = parent.children[i]
                    node = child.id === id ? child : this.findNodeById(parent.children[i], id)
                    if (node) {
                        return {...node, index: i}
                    }
                }
            }

            return null
        },
        updateNode(model) {
            const parent = this.findNodeById(this.tree, this.model.parent.id)
            const children = this.findNodeById(parent, this.model.id)
            parent.children[children.index] = this.generateNode(model)
        }
    }
}

export default mixin
